export default __webpack_public_path__ + "static/media/azure-logic-app.6384099c.svg";